(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sher-mobile-navigation"] && !Shopify.designMode) return;
  try {
    class SherMobileNavigation extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.drawer = this.closest('header-drawer');
      this.container = this.closest('.menu-drawer-container');
      this.addEventListener('toggle', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLDetailsElement)) return;
        target.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(target.open));
        if (target.parentElement === this && target.open) {
          for (const sibling of this.children) {
            if (sibling instanceof HTMLDetailsElement && sibling !== target) sibling.open = false;
          }
        }
      }, { ...options, capture: true });
      this.container?.addEventListener('toggle', (event) => {
        if (event.target === this.container && this.container.open) this.reset();
      }, options);
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        this.drawer?.close();
      }, options);
      this.reset();
    }
    reset() {
      for (const details of this.querySelectorAll('details')) {
        details.open = details.hasAttribute('data-sher-default');
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('sher-mobile-navigation')) {
    customElements.define('sher-mobile-navigation', SherMobileNavigation);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sher-necklace-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sher-necklace-guide')){
 customElements.define('sher-necklace-guide',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.data=JSON.parse(this.querySelector('[data-neck-config]').textContent);this.length=50;this.build='average';this.unit='cm';this.pendingLength=50;this.pendingBuild='average';this.request=0;
   this.photo=this.querySelector('[data-neck-photo]');
   this.querySelectorAll('[data-neck-cm]').forEach(b=>b.addEventListener('click',()=>this.choose(Number(b.dataset.neckCm),this.pendingBuild)));
   this.querySelectorAll('[data-neck-build-option]').forEach(b=>b.addEventListener('click',()=>this.choose(this.pendingLength,b.dataset.neckBuildOption)));
   this.querySelectorAll('[data-neck-unit]').forEach(b=>b.addEventListener('click',()=>{this.unit=b.dataset.neckUnit;this.labels()}));
  }
  text(key,values={}){let s=this.data.copy[key]||key;Object.entries(values).forEach(([k,v])=>s=s.replaceAll('__'+k.toUpperCase()+'__',v));return s}
  display(cm){return this.unit==='cm'?String(cm):(cm/2.54).toFixed(1)}
  labels(){
   this.querySelector('[data-neck-length]').textContent=this.display(this.length)+' '+this.text(this.unit);
   this.querySelector('[data-neck-build]').textContent=this.text(this.build);
   this.querySelectorAll('[data-neck-cm]').forEach(b=>{const cm=Number(b.dataset.neckCm);b.setAttribute('aria-pressed',String(cm===this.length));b.querySelector('span').textContent=this.display(cm);b.querySelector('small').textContent=this.text(this.unit)});
   this.querySelectorAll('[data-neck-build-option]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.neckBuildOption===this.build)));
   this.querySelectorAll('[data-neck-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.neckUnit===this.unit)));
  }
  async choose(length,build){
   const request=++this.request,source=this.data.images[build+'-'+length];if(!source)return;this.pendingLength=length;this.pendingBuild=build;
   const loading=this.querySelector('.sng-loading'),error=this.querySelector('[data-neck-error]');error.hidden=true;loading.hidden=false;this.querySelector('.sng-photo').setAttribute('aria-busy','true');
   try{
    const img=new Image();img.src=source+(source.includes('?')?'&':'?')+'width=800';await img.decode();if(request!==this.request)return;
    this.photo.src=img.src;this.length=length;this.build=build;this.labels();this.photo.alt=this.text('alt',{length,neck:this.text(build).toLowerCase()});this.querySelector('[data-neck-status]').textContent=this.text('selected',{length,neck:this.text(build)});
   }catch(e){if(request===this.request){error.hidden=false;this.pendingLength=this.length;this.pendingBuild=this.build}}finally{if(request===this.request){loading.hidden=true;this.querySelector('.sng-photo').setAttribute('aria-busy','false')}}
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sher-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    function init() {
      const root = document.querySelector('#judgeme_product_reviews');
      if (!root || root.dataset.sherReviewPolish) return;
      root.dataset.sherReviewPolish = 'true';
      let frame;
      function refresh() {
        root.querySelectorAll('.jdgm-review-content__body-content').forEach(content => {
          const walker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
          let textNode;
          while ((textNode = walker.nextNode())) {
            const corrected = textNode.nodeValue.replace(/([\p{L}\p{N}])\uFFFD(?=[\p{L}\p{N}])/gu, '$1’');
            if (corrected !== textNode.nodeValue) textNode.nodeValue = corrected;
          }
        });
        root.querySelectorAll('.jm-histogram-row').forEach(row => {
          const label = row.getAttribute('aria-label') || '';
          const percentage = label.match(/[\d.,]+\s*%/);
          const frequency = row.querySelector('.jm-histogram-row__frequency');
          if (percentage && frequency) frequency.dataset.sherPercentage = percentage[0];
        });
        root.querySelectorAll('.jm-average-rating-display .jm-star-rating, .jm-review-item .jm-star-rating').forEach(stars => {
          const label = stars.getAttribute('aria-label') || '';
          const rating = parseFloat(label.replace(',', '.'));
          if (!Number.isFinite(rating) || rating < 0 || rating > 5) return;
          stars.dataset.sherRating = String(rating);
          stars.style.setProperty('--sher-rating-fill', `${rating * 20}%`);
        });
      }
      new MutationObserver(() => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(refresh);
      }).observe(root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
      refresh();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sher-ring-sizer-dialog"] && !Shopify.designMode) return;
  try {
    const SizerMath = Object.freeze({
  version: '0.7.0-pilot',
  readingCount: 2,
  card: Object.freeze({longMm:85.60,shortMm:53.98}),
  breadthCalibration: Object.freeze({breadthMm:21.9, knownUS:10.5, chartDiameterMm:20.2, factor:20.2/21.9, sampleCount:1, validated:false}),
  guideMaxPixels(stageWidth) {
    if (!Number.isFinite(stageWidth) || stageWidth <= 40) throw new RangeError('A usable measurement area is required');
    return Math.floor((stageWidth - 32) * 2) / 2;
  },
  usChart: Object.freeze([14.1,14.5,14.9,15.3,15.7,16.1,16.5,16.9,17.3,17.7,18.1,18.5,19.0,19.4,19.8,20.2,20.6,21.0,21.4,21.8,22.2,22.6]),
  sizeFromInsideDiameter(diameter) {
    if (!Number.isFinite(diameter) || diameter <= 0) throw new RangeError('Positive finite inside diameter required');
    if (diameter < this.usChart[0] || diameter > this.usChart[this.usChart.length - 1]) return null;
    for (let i = 0; i < this.usChart.length - 1; i++) {
      if (diameter <= this.usChart[i+1]) {
        const size = 3 + i/2 + (diameter-this.usChart[i])/(this.usChart[i+1]-this.usChart[i])/2;
        return Math.round((size + 1e-10) * 4) / 4;
      }
    }
    return 13.5;
  },
  diameterFromUS(size) {
    if (!Number.isFinite(size) || size < 3 || size > 13.5 || Math.abs(size*4-Math.round(size*4)) > 1e-8) throw new RangeError('US size 3–13.5 in quarter steps required');
    const position=(size-3)*2, lo=Math.floor(position), hi=Math.ceil(position);
    return this.usChart[lo] + (this.usChart[hi]-this.usChart[lo])*(position-lo);
  },
  scaleFromReference(pixels, mm) {
    if (![pixels,mm].every(x=>Number.isFinite(x)&&x>0)) throw new RangeError('Positive reference dimensions required');
    return pixels/mm;
  },
  referenceMm(reference, orientation) {
    if (reference !== 'card' || !['portrait','landscape'].includes(orientation)) throw new RangeError('Unknown calibration reference');
    return orientation === 'portrait' ? this.card.longMm : this.card.shortMm;
  },
  summarise(readings, method = 'breadth') {
    if (!['breadth','ring'].includes(method)) throw new RangeError('Unknown method');
    if (readings.length !== this.readingCount || !readings.every(x => Number.isFinite(x) && x > 0)) throw new RangeError('Two valid measurements required');
    const mean = (readings[0] + readings[1]) / 2;
    const spread = Math.abs(readings[0] - readings[1]);
    const repeatThresholdMm = method === 'ring' ? 0.2 : 0.8;
    const repeatCheck = spread > repeatThresholdMm + 1e-10;
    const factor = method === 'breadth' ? this.breadthCalibration.factor : 1;
    const diameters = readings.map(x => x * factor);
    const estimatedDiameterMm = mean * factor;
    const outsideChart = diameters.some(x => x < this.usChart[0] || x > this.usChart.at(-1));
    const chartPosition = estimatedDiameterMm < this.usChart[0] ? 'below' : estimatedDiameterMm > this.usChart.at(-1) ? 'above' : outsideChart ? 'straddles' : 'within';
    return {
      method, meanMm: mean, spread, repeatThresholdMm, repeatCheck, estimatedDiameterMm, chartPosition,
      calibrationModel: method === 'breadth' ? this.breadthCalibration : null,
      rangeMm: [Math.min(...readings), Math.max(...readings)],
      breadthMm: method === 'breadth' ? mean : null,
      insideDiameterMm: method === 'ring' ? mean : null,
      circumferenceMm: method === 'ring' ? Math.PI * mean : null,
      estimatedUS: !outsideChart ? this.sizeFromInsideDiameter(estimatedDiameterMm) : null,
      status: outsideChart ? 'outside-chart' : repeatCheck ? 'estimate-recheck-readings' : method === 'breadth' ? 'experimental-one-point-estimate' : 'inside-diameter-chart-estimate',
      fitRecommendation: null
    };
  }
});
if (typeof module !== 'undefined') module.exports = SizerMath;

const SIZER_STYLE=":host{display:block;color:#493423;background:#fff;font-family:var(--font-body--family,Arial,sans-serif);font-size:14px;line-height:1.55;text-align:left;color-scheme:light}\n*{box-sizing:border-box}h1,h2,h3,p{margin:0}button,input,select{font:inherit}button,select,input[type=checkbox],input[type=range],summary{cursor:pointer}button{touch-action:manipulation}button:disabled{opacity:.45;cursor:not-allowed}button:focus-visible,input:focus-visible,select:focus-visible,summary:focus-visible{outline:2px solid #96723c;outline-offset:3px}[hidden]{display:none!important}a{color:inherit}\n.shell{--inset:20px;max-width:560px;margin:auto;padding:20px var(--inset) 26px;background:white}.steps{display:flex;gap:8px;justify-content:space-between;margin-bottom:24px}.step{display:flex;align-items:center;gap:6px;flex:1;font-size:9px;font-weight:600;letter-spacing:.07em;color:#8a8179;white-space:nowrap}.step:after{content:'';flex:1;height:1px;background:#ded8cf;margin-left:2px}.step:last-child{flex:0}.step:last-child:after{display:none}.step b{display:grid;place-items:center;flex:none;width:25px;height:25px;border-radius:50%;background:#f4f0e9;font-size:11px;letter-spacing:0;font-weight:500}.step.active{color:#493423}.step.active b{background:#493423;color:white}\nh1,h2{font-family:var(--font-heading--family,inherit);font-size:22px;line-height:1.25;letter-spacing:.065em;font-weight:700;text-transform:uppercase;margin:0 0 12px}h3{font-weight:650;font-size:15px;line-height:1.35;margin-bottom:8px}.intro{color:#6b6054;margin-bottom:22px}.small{font-size:12px;line-height:1.5;color:#73695e}.primary,.secondary{display:block;width:100%;min-height:48px;border:1px solid #493423;border-radius:5px;background:#493423;color:white;font-family:var(--font-heading--family,inherit);font-size:12px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;padding:12px;text-align:center;margin-top:14px}.secondary{background:white;color:#493423}.link{border:0;background:transparent;color:#6b6054;text-decoration:underline;text-underline-offset:4px;font-size:12px;padding:10px;display:block;margin:6px auto 0}.privacy{margin-top:20px;text-align:center;font-size:11px;line-height:1.6;color:#73695e}\n.intro-steps{list-style:none;background:#f7f3eb;border-radius:8px;padding:20px 16px;margin:0 0 20px;display:grid;gap:20px}.intro-steps li{display:flex;gap:14px;align-items:flex-start}.intro-steps .number{display:grid;place-items:center;border:1px solid #493423;border-radius:50%;width:30px;height:30px;flex:none;font-size:15px}.intro-steps strong{display:block;font-size:15px;margin-bottom:3px}.intro-steps p{font-size:12px;color:#73695e}.need{display:flex;align-items:center;gap:12px;font-size:12px;margin-bottom:22px}.need svg{width:28px;height:24px;flex:none}\n.field{margin:16px 0}.field label{display:block;font-size:12px;margin-bottom:6px}.field select{width:100%;min-height:44px;border:1px solid #b6a99c;background:white;border-radius:4px;padding:9px 12px;color:#493423;font-size:14px}.reading{font-size:11px;color:#73695e;margin-bottom:10px}.page-measure h2,.page-result h2{text-align:center}.page-measure .reading{text-align:center}.orientation{font-size:12px;margin:14px 0;line-height:1.55}.guide{display:flex;align-items:center;gap:12px;padding:12px;background:#f7f3eb;border-radius:7px;margin:14px 0}.hand-art{flex:0 0 45%;position:relative;align-self:center}.hand-art img{display:block;width:100%;height:auto;mix-blend-mode:multiply}.hand-art .band{position:absolute;left:60%;top:36%;height:15%;width:4%;background:#c4a36c66;border-top:1px solid #96723c;border-bottom:1px solid #96723c}.hand-art .band--knuckle{left:69.5%;top:35.5%;height:13%}.guide h3{font-size:12px;margin-bottom:5px}.guide p{font-size:11px;line-height:1.5;color:#6b6054}.guide svg{width:72px;height:72px;flex:none}.guide-note{text-align:center;margin:16px 0}.repeat-note{padding:10px 12px;border-left:2px solid #96723c;background:#f7f3eb;margin:12px 0;font-size:12px}\n.calibration,.finger-stage{margin-inline:calc(-1 * var(--inset))}.measure{position:relative;overflow:hidden;background:white;margin-top:20px;margin-bottom:20px}.calibration .measure{min-height:134px}.gap{box-sizing:content-box;position:absolute}.cal-gap{top:12px;left:0;right:0;border-top:2px solid #493423;border-bottom:2px solid #493423;background:transparent}.card-shape{position:absolute;right:24%;top:0;height:100%;border:1px solid #b3a38e;border-radius:12px;background:#f5f0e7}.card-chip{position:absolute;right:65%;top:65%;width:25px;height:20px;border:1px solid #b3a38e;border-radius:4px;background:linear-gradient(90deg,transparent 47%,#b3a38e 49%,#b3a38e 51%,transparent 53%)}\n.finger-stage{height:260px;margin-top:14px;margin-bottom:16px;overflow:hidden}.finger-stage .gap{top:50%;left:0;right:0;transform:translateY(-50%);border-top:2px solid #493423;border-bottom:2px solid #493423;background:#f7f3eb}.stage-label{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;font-size:10px;letter-spacing:.07em;color:#938674;pointer-events:none}.ring-stage{margin-inline:0}.ring-stage .gap{left:50%;right:auto;top:50%;transform:translate(-50%,-50%);border:2px solid #493423;border-radius:50%;background:#f7f3eb}.ring-stage .gap:after{content:'';position:absolute;top:50%;left:0;right:0;border-top:1px dashed #a6947e}\n.control-label{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:12px}.control-label output{font-size:11px;color:#73695e;font-variant-numeric:tabular-nums}.controls{display:grid;grid-template-columns:44px minmax(0,1fr) 44px;align-items:center;gap:12px;margin:10px 0 4px}.controls button{width:44px;height:44px;border:1px solid #b6a99c;border-radius:4px;background:white;color:#493423;font-size:24px}.controls input{width:100%;min-width:0;min-height:44px;accent-color:#493423}.fine-hint{font-size:11px;color:#73695e;text-align:center;margin:0 0 16px}.check{display:flex;gap:10px;align-items:flex-start;font-size:12px;margin:20px 0 16px;cursor:pointer}.check input{flex:none;width:20px;height:20px;margin:0;accent-color:#493423}.warning,.invalid{font-size:12px;background:#f7f3eb;padding:12px;border-left:2px solid #96723c;margin:16px 0}.result-intro{text-align:center}.resultbox{background:#f7f3eb;border-radius:8px;padding:22px 18px;text-align:center;margin:20px 0 16px}.resultbox>p{font-size:12px}.big{font-family:var(--font-heading--family,inherit);font-size:54px;font-weight:700;letter-spacing:-.03em;line-height:1.15;margin:10px 0}.us-prefix{font-size:23px;letter-spacing:0}.result-finger{margin-top:8px;color:#73695e}.product-match{border-top:1px solid #d9cfc2;margin-top:20px;padding-top:16px;font-size:12px}.product-match strong{display:block;font-size:20px;margin:5px 0}.product-match p+p{margin-top:5px}.product-name{color:#73695e}.match-note{font-size:11px;color:#73695e;margin-top:6px}details{border:1px solid #b6a99c;border-radius:5px;margin:16px 0 22px}summary{display:flex;align-items:center;justify-content:space-between;gap:12px;list-style:none;font-size:13px;padding:14px}summary::-webkit-details-marker{display:none}summary:after{content:'';width:8px;height:8px;border-bottom:1.5px solid;border-right:1.5px solid;transform:rotate(45deg);margin-right:3px}details[open] summary:after{transform:rotate(225deg)}.detail-body{padding:0 14px 16px}.detail-body p{margin:10px 0}.detail-body dl{font-size:11px}.detail-body dl>div{display:flex;justify-content:space-between;gap:10px;border-bottom:1px solid #eee8df;padding:7px 0}dt{color:#73695e}dd{margin:0}.fit{margin:22px 0}.fit p{font-size:12px;color:#73695e}.outside{margin-bottom:10px}\n@media(max-width:359px){.shell{--inset:16px}h1,h2{font-size:19px}.step{font-size:8px;gap:4px}.guide{gap:8px;padding:10px}.guide p{font-size:11px}.big{font-size:48px}}\n@media(min-width:650px){.shell{--inset:28px}h1,h2{font-size:24px}.guide p{font-size:12px}.intro-steps p{font-size:13px}}\n";
if (!customElements.get('sher-ring-sizer')) {
  customElements.define('sher-ring-sizer', class extends HTMLElement {
    connectedCallback() {
      if (this.root) return;
      this.root = this.shadowRoot || this.attachShadow({ mode: 'open' });
      const config = this.querySelector('script[type="application/json"]');
      this.copy = config ? JSON.parse(config.textContent) : {};
      const productConfig = this.querySelector('[data-sizer-product]');
      this.productData = productConfig ? JSON.parse(productConfig.textContent) : null;
      this.state = { page: 'intro', method: 'breadth', reference: 'card', orientation: 'landscape', calPx: 260, scale: null, hand: null, finger: 'index', readings: [], cardConfirmed: false, calibration: null, rawPixels: [] };
      this.screen = () => [window.innerWidth, window.devicePixelRatio, window.visualViewport?.scale || 1];
      this.watch = () => {
        if (this.state.scale && this.screen().some((v, i) => Math.abs(v - this.calScreen[i]) > 0.005)) {
          this.state.scale = null;
          this.state.cardConfirmed = false;
          this.state.calibration = null;
          this.state.rawPixels = [];
          this.state.readings = [];
          this.state.page = 'cal';
          this.state.resetNotice = true;
          this.render();
        }
      };
      window.addEventListener('resize', this.watch);
      window.visualViewport?.addEventListener('resize', this.watch);
      this.clickListener = e => this.click(e);
      this.inputListener = e => this.input(e);
      this.root.addEventListener('click', this.clickListener);
      this.root.addEventListener('input', this.inputListener);
      this.render();
    }
    disconnectedCallback() {
      window.removeEventListener('resize', this.watch);
      window.visualViewport?.removeEventListener('resize', this.watch);
      this.root.removeEventListener('click', this.clickListener);
      this.root.removeEventListener('input', this.inputListener);
      this.root = null;
    }
    t(key) { return this.escape(this.copy[key] || key); }
    escape(text) { return String(text).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    btn(key, action, secondary = false, disabled = false) {
      return `<button type="button" class="${secondary ? 'secondary' : 'primary'}" data-action="${action}" ${disabled ? 'disabled' : ''}>${this.t(key)}</button>`;
    }
    link(key, action) { return `<button type="button" class="link" data-action="${action}">${this.t(key)}</button>`; }
    select(key, values, current) {
      return `<div class="field"><label for="${key}">${this.t(key)}</label><select id="${key}">${values.map(v => `<option value="${v}" ${v === current ? 'selected' : ''}>${this.t(v)}</option>`).join('')}</select></div>`;
    }
    art(knuckle) {
      return `<div class="hand-art"><img src="https://cdn.shopify.com/s/files/1/0689/3525/4147/files/sher-ring-sizer-palm-up-sketch.png?v=1789980677&width=480" width="480" height="320" alt="${this.t(knuckle ? 'knuckle_landmark' : 'landmark')}" decoding="async"><span class="band ${knuckle ? 'band--knuckle' : ''}" aria-hidden="true"></span></div>`;
    }
    productMatch(size) {
      const p = this.productData;
      if (!p || !Number.isFinite(size)) return [];
      const index = p.options.findIndex(name => /size/i.test(name));
      if (index < 0) return [];
      const selected = p.variants.find(v => String(v.id) === String(this.selectedVariantId || p.selected));
      const sizes = new Map();
      for (const variant of p.variants) {
        if (selected && variant.options.some((value, i) => i !== index && value !== selected.options[i])) continue;
        const label = variant.options[index].trim().replace(/^US\s*/i,'');
        if (!/^\d+(?:\.\d+)?$/.test(label)) continue;
        const value = Number(label);
        if (!sizes.has(value)) sizes.set(value,{size:value,available:false});
        sizes.get(value).available ||= variant.available;
      }
      const values = [...sizes.values()];
      const distance = Math.min(...values.map(v => Math.abs(v.size - size)));
      return values.filter(v => Math.abs(Math.abs(v.size - size) - distance) < 1e-8).sort((a,b) => a.size-b.size);
    }
    matchMarkup(result) {
      if (result.estimatedUS === null || result.repeatCheck || !this.productData) return '';
      const matches = this.productMatch(result.estimatedUS);
      if (!matches.length) return `<div class="product-match"><p>${this.t('no_sizes')}</p></div>`;
      return `<div class="product-match"><p>${this.t(matches.length > 1 ? 'closest_tie' : 'closest')}</p><p class="product-name">${this.escape(this.productData.title)}</p>${matches.map(m => {
        const diff = m.size - result.estimatedUS;
        return `<strong>${this.t('us_prefix')} ${m.size}</strong>${!m.available ? `<p class="small">${this.t('sold_out')}</p>` : ''}${Math.abs(diff) > 0.5 ? `<p class="match-note">${Math.abs(diff)} ${this.t(diff > 0 ? 'match_larger' : 'match_smaller')}</p>` : ''}`;
      }).join('')}</div>`;
    }
    refreshProductSelection() {
      const ids = new Set((this.productData?.variants || []).map(v => String(v.id)));
      const selected = [...document.querySelectorAll('form[action*="/cart/add"] [name="id"]')].find(el => ids.has(el.value) && !el.disabled);
      this.selectedVariantId = selected?.value || this.productData?.selected;
      if (this.state.page === 'result') this.render();
    }
    guideStyle() {
      return this.state.method === 'ring' ? `width:${this.state.measurePx}px;height:${this.state.measurePx}px` : `height:${this.state.measurePx}px`;
    }
    guidePixels() {
      const rect = this.root.querySelector('.gap').getBoundingClientRect();
      return (this.state.page === 'cal' || this.state.method === 'breadth' ? rect.height : rect.width) - 4;
    }
    controls(min, max, value, label) {
      return `<div class="controls"><button type="button" data-action="minus" aria-label="${this.t('smaller')}">−</button><input id="gap-slider" type="range" min="${min}" max="${max}" step="0.5" value="${value}" aria-label="${this.t(label)}"><button type="button" data-action="plus" aria-label="${this.t('larger')}">+</button></div>`;
    }
    check(key) { return `<label class="check"><input id="confirmed" type="checkbox"><span>${this.t(key)}</span></label>`; }
    prepareMeasurement() {
      this.state.page = 'measure';
      this.state.measurePx = Math.max(8, Math.min(this.maxGuide(), 19 * this.state.scale));
    }
    maxGuide() {
      const stage = this.root?.querySelector('.finger-stage');
      if (stage?.clientHeight > 40) return SizerMath.guideMaxPixels(this.state.method === 'ring' ? Math.min(stage.clientWidth,stage.clientHeight) : stage.clientHeight);
      return SizerMath.guideMaxPixels(260);
    }
    syncMeasurementControls() {
      if (this.state.page !== 'measure') return;
      const slider = this.root.querySelector('#gap-slider');
      const max = this.maxGuide();
      slider.min = '8'; slider.max = String(max);
      slider.value = String(Math.max(8, Math.min(max, this.state.measurePx)));
      this.state.measurePx = Number(slider.value);
      this.root.querySelector('.gap').style.cssText = this.guideStyle();
      this.updateMeasurementReadout();
    }
    updateMeasurementReadout() {
      const slider = this.root.querySelector('#gap-slider');
      const output = this.root.querySelector('#width-readout');
      if (output) output.textContent = `${(this.state.measurePx / this.state.scale).toFixed(1)} ${this.copy.mm || 'mm'}`;
      const limit = this.root.querySelector('#width-limit');
      if (limit) limit.hidden = Number(slider.max) - this.state.measurePx > 0.5;
    }
    maxCalibration() { return 500; }
    calibrationHeight() { return this.state.calPx; }
    calibrationStyle() { return `height:${this.state.calPx}px`; }
    syncCardShape() {
      const shape = this.root.querySelector('.card-shape');
      if (shape) shape.style.width = `${this.state.calPx * SizerMath.card.longMm / SizerMath.card.shortMm}px`;
    }
    syncCalibrationControls() {
      if (this.state.page !== 'cal') return;
      const slider = this.root.querySelector('#gap-slider');
      slider.max = String(this.maxCalibration());
      slider.value = String(Math.max(100, Math.min(Number(slider.max), this.state.calPx)));
      this.state.calPx = Number(slider.value);
      this.root.querySelector('.gap').style.cssText = this.calibrationStyle();
      this.root.querySelector('.calibration .measure').style.height = `${this.calibrationHeight()+28}px`;
      this.syncCardShape();
    }
    render() {
      const s = this.state, t = k => this.t(k);
      let body = '';
      if (s.page === 'intro') {
        body = `<h1 tabindex="-1">${t('title')}</h1><p class="intro">${t('intro')}</p><ol class="intro-steps">${['setup','measure','result'].map((k,i)=>`<li><span class="number" aria-hidden="true">${i+1}</span><div><strong>${t('intro_'+k)}</strong><p>${t('intro_'+k+'_text')}</p></div></li>`).join('')}</ol><p class="need"><svg viewBox="0 0 28 24" fill="none" aria-hidden="true"><rect x="1" y="3" width="26" height="18" rx="3" stroke="currentColor" stroke-width="1.5"/><path d="M1 8H27 M5 14H12 M5 17H9" stroke="currentColor" stroke-width="1.5"/></svg>${t('need')}</p>${this.btn('start','start')}${this.btn('ring_start','start-ring',true)}<p class="privacy">${t('privacy')}</p>`;
      } else if (s.page === 'cal') {
        const max = this.maxCalibration(); s.calPx = Math.min(max, Math.max(100,s.calPx));
        body = `${s.resetNotice ? `<p class="invalid" role="alert">${t('reset_notice')}</p>` : ''}<h2 tabindex="-1">${t('cal_title')}</h2><p>${t('cal_intro')}</p><p class="small" style="margin-top:8px">${t('card_help')}</p><div class="calibration"><div class="measure" style="height:${this.calibrationHeight()+28}px"><div class="gap cal-gap" style="${this.calibrationStyle()}"><div class="card-shape" aria-hidden="true"><span class="card-chip"></span></div></div></div></div><p class="control-label">${t('cal_label')}</p>${this.controls(100,max,s.calPx,'cal_label')}<p class="fine-hint">${t('control_hint')}</p>${this.check('match')}${this.btn('confirm','calibrate',false,true)}<p class="privacy">${t('scale_note')}</p>${this.link('back','intro')}`;
      } else if (s.page === 'measure') {
        const n = s.readings.length, ring = s.method === 'ring';
        const knuckle = !ring && n === 0;
        const fingerCopy = key => knuckle ? 'knuckle_' + key : ({title:'breadth_title',help:'breadth_help'}[key] || key);
        const measureLabel = ring ? 'ring_measure_label' : fingerCopy('measure_label');
        body = `<p class="reading">${t('reading')} ${n+1} ${t('of')} 2</p><h2 tabindex="-1">${t(ring ? 'ring_title':fingerCopy('title'))}</h2>${ring ? '' : this.select('finger',['index','middle','ring','little','thumb'],s.finger)}${!ring ? `<p class="orientation">${t('orientation')}</p>` : ''}<div class="guide">${ring ? '<svg viewBox="0 0 120 112" aria-hidden="true"><circle cx="60" cy="56" r="40" fill="none" stroke="#b59560" stroke-width="10"/><path d="M25 56H95 M25 46V66 M95 46V66" stroke="#493423" stroke-width="2"/></svg>' : this.art(knuckle)}<div>${!ring ? `<h3>${t(fingerCopy('guide_title'))}</h3>` : ''}<p>${t(ring?'ring_help':fingerCopy('help'))}</p></div></div>${n > 0 ? `<p class="repeat-note">${t(ring?'ring_repeat_help':'repeat_help')}</p>` : ''}<p class="small guide-note">${t(ring?'ring_guide_note':fingerCopy('guide_note'))}</p><div class="measure finger-stage ${ring?'ring-stage':''}"><div class="gap" style="${this.guideStyle()}">${!ring ? `<span class="stage-label" aria-hidden="true">${t(fingerCopy('place_finger'))}</span>` : ''}</div></div><p class="control-label"><span>${t(measureLabel)}</span><output id="width-readout" for="gap-slider"></output></p>${this.controls(8,this.maxGuide(),s.measurePx,measureLabel)}<p id="width-limit" class="small warning" hidden>${t('width_limit')}</p>${this.check(ring?'ring_aligned':fingerCopy('aligned'))}${this.btn(n===0?'save_first':'save_second','save',false,true)}${n===0 ? `<p class="privacy">${t(ring?'second_note':'breadth_second_note')}</p>` : ''}${this.link('back','previous')}`;
      } else if (s.page === 'fallback') {
        body = `<h2 tabindex="-1">${t('fallback_title')}</h2><p class="intro">${t('fallback_text')}</p>${this.btn('restart','reset')}`;
      } else if (s.page === 'result') {
        const r = SizerMath.summarise(s.readings,s.method); this.result=r;
        const ring=s.method==='ring';
        const metric=(key,val)=>`<div><dt>${t(key)}</dt><dd>${val.toFixed(1)} ${t('mm')}</dd></div>`;
        const headline=r.estimatedUS===null ? `<h3 class="outside">${t('outside_chart')}</h3><p>${t('outside_chart_note')}</p>` : `<p>${t('us_size')}</p><div class="big"><span class="us-prefix">${t('us_prefix')}</span> ${r.estimatedUS}</div>${!ring?`<p class="result-finger">${t(s.finger)}</p>`:''}${this.matchMarkup(r)}`;
        body=`<h2 tabindex="-1">${t(r.estimatedUS===null?'no_result_title':'result_title')}</h2>${r.estimatedUS!==null ? `<p class="small result-intro">${t(ring?'result_intro':'breadth_result_intro')}</p>`:''}<div class="resultbox">${headline}</div>${r.repeatCheck && r.estimatedUS!==null ? `<p class="warning" role="status">${t(ring?'inconsistent':'breadth_inconsistent')}</p>`:''}<details><summary>${t('details')}</summary><div class="detail-body"><dl>${metric(ring?'inside_diameter':'width',r.meanMm)}${metric('spread',r.spread)}<div><dt>${t('range')}</dt><dd>${r.rangeMm.map(x=>x.toFixed(1)).join('–')} ${t('mm')}</dd></div></dl><p class="small">${t('scale_details')}: ${s.scale.toFixed(4)} px/mm · ${s.calibration.referenceMm} mm</p><p class="small">${t('range_note')}</p>${this.btn('download','download',true)}</div></details><div class="fit"><h3>${t('next_title')}</h3><p>${t(ring?'next_text':'breadth_next')}</p></div>${r.estimatedUS===null ? this.btn('recalibrate','recalibrate') : this.btn('back_product','close')+this.btn('repeat','repeat',true)}${!ring?this.link('check_ring','switch-ring'):''}${r.estimatedUS!==null?this.link('recalibrate','recalibrate'):''}`;
      }
      const active=['intro','cal'].includes(s.page)?0:s.page==='result'?2:1;
      const steps=s.page==='intro'?'':`<nav class="steps" aria-label="${t('eyebrow')}">${['step_setup','step_measure','step_result'].map((k,i)=>`<span class="step ${i<=active?'active':''}" ${i===active?'aria-current="step"':''}><b aria-hidden="true">${i<active?'✓':'0'+(i+1)}</b>${t(k)}</span>`).join('')}</nav>`;
      this.root.innerHTML=`<style>${SIZER_STYLE}</style><section class="shell page-${s.page}" aria-label="${t('eyebrow')}">${steps}${body}</section>`;
      this.syncCalibrationControls(); this.syncMeasurementControls();
      if(s.page!=='intro') this.root.querySelector('h2')?.focus({preventScroll:true});
      this.dispatchEvent(new CustomEvent('sher-sizer:step',{bubbles:true}));
    }
    input(e) {
      const s = this.state, el = e.target;
      if (el.id === 'gap-slider') {
        const val = Number(el.value);
        if (s.page === 'cal') s.calPx = val; else s.measurePx = val;
        if (s.page === 'cal') {
          this.root.querySelector('.gap').style.cssText = this.calibrationStyle();
          this.root.querySelector('.calibration .measure').style.height = `${this.calibrationHeight() + 28}px`;
          this.syncCardShape();
        }
        else { this.root.querySelector('.gap').style.cssText = this.guideStyle(); this.updateMeasurementReadout(); }
        this.root.querySelector('#confirmed').checked = false;
        this.root.querySelector('.primary').disabled = true;
      } else if (el.id === 'finger') {
        s.finger = el.value; s.readings = []; s.rawPixels = []; this.prepareMeasurement(); this.render();
      } else if (el.id === 'confirmed') this.root.querySelector('.primary').disabled = !el.checked;

    }
    click(e) {
      const el = e.target.closest('button'); if (!el || el.disabled) return;
      const s = this.state, a = el.dataset.action;
      if (a === 'close') { this.closest('dialog')?.close(); return; }
      if (a === 'minus' || a === 'plus') {
        const slider = this.root.querySelector('#gap-slider');
        a === 'plus' ? slider.stepUp() : slider.stepDown();
        slider.dispatchEvent(new Event('input', {bubbles:true})); return;
      }
      if (a === 'download') { this.download(); return; }
      if (a === 'intro') s.page = 'intro';
      if (a === 'start' || a === 'start-ring' || a === 'reset') {
        s.method = a === 'start-ring' ? 'ring' : 'breadth';
        s.page = a === 'reset' ? 'intro' : 'cal'; s.scale = null; s.cardConfirmed = false; s.calibration = null; s.readings = []; s.rawPixels = []; s.resetNotice = false;
      }
      if (a === 'recalibrate') { s.page = 'cal'; s.scale = null; s.cardConfirmed = false; s.calibration = null; s.readings = []; s.rawPixels = []; s.resetNotice = false; }
      if (a === 'calibrate') {
        if (!this.root.querySelector('#confirmed')?.checked) return;
        const referenceMm = SizerMath.card.shortMm;
        const actualPixels = this.guidePixels();
        if (!Number.isFinite(actualPixels) || actualPixels <= 0) return;
        s.scale = SizerMath.scaleFromReference(actualPixels, referenceMm);
        s.calibration = {reference:'card', referenceMm, pixels:actualPixels, axis:'vertical', orientation:'landscape', confirmation:'card-edges-user-confirmed'};
        this.calScreen = this.screen(); s.resetNotice = false; s.cardConfirmed = true;
        s.readings = []; s.rawPixels = []; this.prepareMeasurement();
      }
      if (a === 'switch-ring') {
        this.watch(); if (!s.scale) return;
        s.method = 'ring'; s.readings = []; s.rawPixels = []; this.prepareMeasurement();
      }
      if (a === 'repeat') { if (!s.cardConfirmed) return; s.readings = []; s.rawPixels = []; this.prepareMeasurement(); }
      if (a === 'previous') {
        if (s.readings.length) { s.measurePx = s.readings.pop() * s.scale; s.rawPixels.pop(); s.page = 'measure'; }
        else s.page = 'cal';
      }
      if (a === 'save') {
        this.watch(); if (s.page !== 'measure' || !s.scale || !s.cardConfirmed || !this.root.querySelector('#confirmed')?.checked) return;
        const pixels = this.guidePixels();
        const value = pixels / s.scale;
        if (!Number.isFinite(value) || value <= 0) return;
        s.readings.push(value); s.rawPixels.push(pixels);
        if (s.readings.length === SizerMath.readingCount) s.page = 'result'; else this.prepareMeasurement();
      }
      if (a === 'fallback') s.page = 'fallback';
      this.render();
    }
    download() {
      const data = {
        methodVersion: SizerMath.version, createdAt: new Date().toISOString(), status: this.result.status, method: this.state.method,
        reference: this.state.reference, cardOrientation: this.state.orientation, referenceMm: this.state.calibration.referenceMm, calibration: this.state.calibration, cardConfirmed: this.state.cardConfirmed, cssPixelsPerMm: this.state.scale,
        viewport: this.calScreen, hand: this.state.method === 'breadth' ? this.state.hand : null, finger: this.state.method === 'breadth' ? this.state.finger : null,
        readingsMm: this.state.readings.map((value, i) => ({axis:this.state.method === 'ring' ? 'inside-diameter' : 'breadth', round:i+1,pixels:this.state.rawPixels[i],value})),
        measurements: this.result,
        physicalGaugeSize: null,
        actualFit: null,
        provisionalRepeatThresholdMm: this.result.repeatThresholdMm,
        estimatedUSSize: this.result.estimatedUS,
        sizeReference: 'https://bn-dam.services.r2net.com/assets/public/education/ring_sizer.pdf',
        fitRecommendation: null, estimateStatus: this.result.status 
      };
      const url = URL.createObjectURL(new Blob([JSON.stringify(data,null,2)],{type:'application/json'}));
      const link = document.createElement('a'); link.href = url; link.download = 'sher-clan-fit-record.json'; link.click();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    }
  });
}

function sherSizerQr(text) {
  const input = new TextEncoder().encode(text);
  if (input.length > 271) throw new RangeError('QR link is too long');
  const bits = [];
  const push = (value, count) => { for (let i = count - 1; i >= 0; i--) bits.push((value >>> i) & 1); };
  push(4, 4); push(input.length, 16);
  input.forEach(value => push(value, 8));
  push(0, Math.min(4, 2192 - bits.length));
  while (bits.length % 8) bits.push(0);
  const data = [];
  for (let i = 0; i < bits.length; i += 8) data.push(bits.slice(i, i + 8).reduce((a, b) => (a << 1) | b, 0));
  for (let i = 0; data.length < 274; i++) data.push(i % 2 ? 17 : 236);
  const multiply = (a, b) => {
    let result = 0;
    while (b) { if (b & 1) result ^= a; a <<= 1; if (a & 256) a ^= 285; b >>>= 1; }
    return result;
  };
  let generator = [1], power = 1;
  for (let i = 0; i < 18; i++) {
    const next = Array(generator.length + 1).fill(0);
    generator.forEach((value, j) => { next[j] ^= value; next[j + 1] ^= multiply(value, power); });
    generator = next; power = multiply(power, 2);
  }
  let offset = 0;
  const blocks = [68, 68, 69, 69].map(length => {
    const payload = data.slice(offset, offset += length), remainder = [...payload, ...Array(18).fill(0)];
    for (let i = 0; i < length; i++) {
      const lead = remainder[i];
      generator.forEach((value, j) => { remainder[i + j] ^= multiply(value, lead); });
    }
    return {payload, ecc: remainder.slice(length)};
  });
  const words = [];
  for (let i = 0; i < 69; i++) blocks.forEach(b => { if (i < b.payload.length) words.push(b.payload[i]); });
  for (let i = 0; i < 18; i++) blocks.forEach(b => words.push(b.ecc[i]));
  const size = 57, matrix = Array.from({length: size}, () => Array(size).fill(null));
  const set = (x, y, value) => { if (x >= 0 && y >= 0 && x < size && y < size) matrix[y][x] = !!value; };
  for (const [x, y] of [[0, 0], [50, 0], [0, 50]]) {
    for (let dy = -1; dy <= 7; dy++) for (let dx = -1; dx <= 7; dx++) {
      set(x + dx, y + dy, dx >= 0 && dx <= 6 && dy >= 0 && dy <= 6 && (dx === 0 || dx === 6 || dy === 0 || dy === 6 || (dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4)));
    }
  }
  for (const y of [6, 28, 50]) for (const x of [6, 28, 50]) {
    if (matrix[y][x] !== null) continue;
    for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) set(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
  }
  for (let i = 8; i < size - 8; i++) {
    if (matrix[6][i] === null) set(i, 6, i % 2 === 0);
    if (matrix[i][6] === null) set(6, i, i % 2 === 0);
  }
  const bch = (value, polynomial, shift) => {
    let remainder = value << shift;
    const degree = v => 31 - Math.clz32(v);
    while (degree(remainder) >= degree(polynomial)) remainder ^= polynomial << (degree(remainder) - degree(polynomial));
    return (value << shift) | remainder;
  };
  const format = bch(8, 1335, 10) ^ 21522;
  for (let i = 0; i < 15; i++) {
    const value = (format >>> i) & 1;
    set(8, i < 6 ? i : i < 8 ? i + 1 : size - 15 + i, value);
    set(i < 8 ? size - i - 1 : i < 9 ? 15 - i : 14 - i, 8, value);
  }
  set(8, size - 8, true);
  const version = bch(10, 7973, 12);
  for (let i = 0; i < 18; i++) {
    set(size - 11 + i % 3, Math.floor(i / 3), (version >>> i) & 1);
    set(Math.floor(i / 3), size - 11 + i % 3, (version >>> i) & 1);
  }
  let index = 0, upward = true;
  for (let right = size - 1; right > 0; right -= 2) {
    if (right === 6) right--;
    for (let step = 0; step < size; step++) {
      const y = upward ? size - 1 - step : step;
      for (let dx = 0; dx < 2; dx++) {
        const x = right - dx;
        if (matrix[y][x] !== null) continue;
        const bit = ((words[index >>> 3] || 0) >>> (7 - (index & 7))) & 1;
        set(x, y, bit ^ ((x + y) % 2 === 0)); index++;
      }
    }
    upward = !upward;
  }
  const path = matrix.flatMap((row, y) => row.flatMap((dark, x) => dark ? [`M${x + 4},${y + 4}h1v1h-1z`] : [])).join('');
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 65" shape-rendering="crispEdges" aria-hidden="true"><rect width="65" height="65" fill="#fff"/><path d="${path}" fill="#241b14"/></svg>`;
}

if (!window.sherSizerDialogBound) {
  window.sherSizerDialogBound = true;
  const mobileView = window.matchMedia('(max-width: 749px)');
  const dialog = document.getElementById('sher-ring-sizer-dialog');
  const handoffUrl = () => {
    const url = new URL(dialog.dataset.handoffUrl);
    const ids = [...document.querySelectorAll('form[action*="/cart/add"] input[name="id"]')];
    const variant = ids.find(input => !input.disabled && /^\d+$/.test(input.value))?.value;
    if (variant) url.searchParams.set('variant', variant);
    if (dialog.dataset.previewTheme) url.searchParams.set('preview_theme_id', dialog.dataset.previewTheme);
    url.searchParams.set('sher_sizer', '1');
    return url.href;
  };
  const showMode = () => {
    const mobile = mobileView.matches;
    const mount = dialog.querySelector('[data-sher-sizer-mount]');
    const handoff = dialog.querySelector('[data-sher-sizer-handoff]');
    dialog.dataset.mode = mobile ? 'mobile' : 'desktop';
    mount.hidden = !mobile; handoff.hidden = mobile;
    if (mobile) {
      if (!mount.firstElementChild) mount.append(dialog.querySelector('[data-sher-sizer-template]').content.cloneNode(true));
      const sizer = mount.querySelector('sher-ring-sizer');
      sizer?.watch?.(); sizer?.refreshProductSelection?.();
    } else {
      const url = handoffUrl();
      const qr = dialog.querySelector('[data-sher-sizer-qr]');
      const input = dialog.querySelector('#sher-sizer-mobile-link');
      input.value = url;
      try { qr.innerHTML = sherSizerQr(url); qr.hidden = false; }
      catch { qr.replaceChildren(); qr.hidden = true; }
      dialog.querySelector('[data-sher-sizer-copy-status]').textContent = '';
    }
    dialog.scrollTop = 0;
  };
  const open = trigger => {
    if (!dialog || dialog.open) return;
    dialog.sherOpener = trigger;
    document.documentElement.classList.add('sher-sizer-open');
    dialog.showModal(); showMode();
    dialog.querySelector('[data-sher-sizer-close]').focus({preventScroll:true});
  };
  if (dialog) {
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('sher-sizer-open');
      if (dialog.sherOpener?.isConnected) dialog.sherOpener.focus({preventScroll:true});
    });
    dialog.addEventListener('click', async event => {
      if (event.target.closest('[data-sher-sizer-close]')) { dialog.close(); return; }
      if (event.target.closest('[data-sher-sizer-copy]')) {
        const input = dialog.querySelector('#sher-sizer-mobile-link');
        const status = dialog.querySelector('[data-sher-sizer-copy-status]');
        try { await navigator.clipboard.writeText(input.value); status.textContent = status.dataset.copied; }
        catch { input.focus(); input.select(); status.textContent = status.dataset.failed; }
      }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog.addEventListener('sher-sizer:step', () => { dialog.scrollTop = 0; });
    mobileView.addEventListener('change', () => { if (dialog.open) showMode(); });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-sher-sizer-open]');
      if (!trigger) return;
      event.preventDefault(); open(trigger);
    });
    if (new URL(window.location.href).searchParams.get('sher_sizer') === '1') {
      open(document.querySelector('[data-sher-sizer-open]'));
    }
  }
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sher-size-guide"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('sher-size-guide')){
 customElements.define('sher-size-guide',class extends HTMLElement{
  connectedCallback(){
   if(this.bound)return;this.bound=true;
   const tabs=[...this.querySelectorAll('[data-sg-tab]')];
   const activate=(name,focus=false)=>{tabs.forEach(t=>{const on=t.dataset.sgTab===name;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1;if(on&&focus)t.focus()});this.querySelectorAll('[data-sg-panel]').forEach(p=>p.hidden=p.dataset.sgPanel!==name)};
   tabs.forEach((t,i)=>{t.addEventListener('click',()=>activate(t.dataset.sgTab));t.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();activate(tabs[n].dataset.sgTab,true)}})});
   if(tabs.length){const hash=location.hash.slice(1);activate(tabs.some(t=>t.dataset.sgTab===hash)?hash:'rings')}
   this.querySelectorAll('[data-sg-chart-select]').forEach(select=>select.addEventListener('change',()=>{const chart=select.closest('[data-sg-chart]');chart.querySelectorAll('[data-sg-metric]').forEach(c=>c.hidden=select.value!=='metric');chart.querySelectorAll('[data-sg-international]').forEach(c=>c.hidden=select.value!=='international')}));
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sher-slidecart"] && !Shopify.designMode) return;
  try {
    (() => {
    const template = document.getElementById('sher-slidecart-protection-template');
    if (!template) return;
    const trustTemplate = document.getElementById('sher-checkout-badges-template');
    const paymentTemplate = document.getElementById('sher-cart-payments-template');

    const shippingTemplate = document.getElementById('sher-shipping-progress-template');
    const syncShipping = drawer => {
      const cart = window.SLIDECART_STATE?.()?.cart;
      const header = drawer.querySelector('.header');
      if (!shippingTemplate || !cart || !Array.isArray(cart.items) || !header) return;
      let panel = drawer.querySelector('.sher-shipping-progress');
      if (!cart.items.length || cart.requires_shipping === false) {
        panel?.remove();
        return;
      }
      const copy = shippingTemplate.dataset;
      const eligibleRegion = ['AU', 'NZ', 'IN'].includes(copy.country);
      const hasSizer = cart.items.some(item => item.handle === 'free-ring-sizer');
      const currency = cart.currency || window.Shopify?.currency?.active;
      const rate = currency === 'AUD' ? 1 : Number(window.Shopify?.currency?.rate);
      const usableRate = Number.isFinite(rate) && rate > 0;
      const jewellery = cart.items.filter(item => item.requires_shipping !== false && !['free-ring-sizer', 'shipping-protection'].includes(item.handle));
      const itemSubtotal = cart.items.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
      const discountFactor = itemSubtotal > 0 ? Math.min(1, Number(cart.total_price) / itemSubtotal) : 0;
      const eligibleValue = jewellery.reduce((sum, item) => sum + Number(item.final_line_price || 0), 0) * discountFactor;
      const threshold = 7500 * rate;
      const showMeter = eligibleRegion && !hasSizer && usableRate && jewellery.length > 0;
      const unlocked = showMeter && eligibleValue > threshold;
      const progress = showMeter ? Math.min(100, Math.max(0, eligibleValue / threshold * 100)) : 0;
      let title = copy.offer;
      let note = copy.regions;
      if (hasSizer) {
        title = copy.calculated;
        note = copy.sizer;
      } else if (!eligibleRegion) {
        title = copy.calculated;
        note = copy.offer + ' · ' + copy.regions;
      } else if (unlocked) {
        title = copy.unlocked;
      } else if (showMeter && eligibleValue < threshold) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'code' }).format(Math.ceil(threshold - eligibleValue) / 100);
        title = copy.remaining.replace('[amount]', amount);
      }
      const signature = JSON.stringify([title, note, showMeter, progress]);
      if (panel?.dataset.shippingState === signature) return;
      if (!panel) {
        panel = shippingTemplate.content.firstElementChild.cloneNode(true);
        header.after(panel);
      }
      panel.dataset.shippingState = signature;
      panel.querySelector('.sher-shipping-progress__title').textContent = title;
      panel.querySelector('.sher-shipping-progress__note').textContent = note;
      panel.querySelector('.sher-shipping-progress__meter').hidden = !showMeter;
      const meter = panel.querySelector('[role="progressbar"]');
      meter.setAttribute('aria-valuenow', String(Math.round(progress)));
      meter.setAttribute('aria-valuetext', title);
      meter.firstElementChild.style.width = progress + '%';
    };


    // App recommendations do not receive Shopify automatic-discount pricing.
    // Keep their display tied to the same removable sale setting as the cards.
    const saleCatalog = document.getElementById('sher-cart-sale-catalog');
    const saleVariants = new Map();
    const saleProducts = new Map();
    saleCatalog?.content.querySelectorAll('[data-variant]').forEach(element => {
      const entry = { ...element.dataset };
      saleVariants.set(entry.variant, entry);
      if (!saleProducts.has(entry.handle)) saleProducts.set(entry.handle, entry);
    });
    const syncSaleRecommendations = drawer => {
      if (!saleCatalog) return;
      drawer.querySelectorAll('.upsell-item').forEach(item => {
        const link = item.querySelector('.upsell-text a[href*="/products/"]');
        const prices = item.querySelector('.upsell-text-prices');
        if (!link || !prices) return;
        const url = new URL(link.href, location.origin);
        const handle = url.pathname.split('/products/')[1]?.split('/')[0];
        const variant = saleVariants.get(url.searchParams.get('variant'));
        const entry = variant?.handle === handle ? variant : saleProducts.get(handle);
        if (!entry) return;
        const signature = [entry.variant, entry.regularMoney, entry.saleMoney, entry.savingMoney].join('|');
        let sale = prices.querySelector('.sher-upsell-sale');
        prices.classList.add('sher-upsell-sale-active');
        if (sale?.dataset.priceSignature === signature) return;
        if (!sale) {
          sale = document.createElement('span');
          sale.className = 'sher-upsell-sale';
          prices.append(sale);
        }
        const regular = document.createElement('s');
        regular.textContent = entry.regularMoney;
        regular.setAttribute('aria-label', 'Original price ' + entry.regularMoney);
        const current = document.createElement('strong');
        current.textContent = entry.saleMoney;
        current.setAttribute('aria-label', 'Sale price ' + entry.saleMoney);
        sale.dataset.priceSignature = signature;
        sale.replaceChildren(regular, current);
      });
    };

    // Carts created before the migration can retain reduced base prices without
    // discount allocations. Recalculate once, preserving quantities and codes.
    let saleCartRefreshStarted = false;
    const refreshLegacySaleCart = () => {
      if (!saleCatalog || saleCartRefreshStarted || typeof window.SLIDECART_UPDATE !== 'function') return;
      const cart = window.SLIDECART_STATE?.()?.cart;
      if (!cart?.items?.length) return;
      const stale = cart.items.some(item => {
        const entry = saleVariants.get(String(item.variant_id || item.id));
        if (!entry) return false;
        const allocations = item.line_level_discount_allocations || item.discount_allocations || [];
        return !allocations.length && Number(item.original_price ?? item.price) < Number(entry.regular);
      });
      if (!stale) return;
      saleCartRefreshStarted = true;
      fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: {} })
      }).then(response => {
        if (!response.ok) throw new Error('Sale cart refresh failed');
        return response.json();
      }).then(() => window.SLIDECART_UPDATE()).catch(() => {
        // Leave the cart usable; Shopify recalculates again at checkout.
      });
    };

    let pending = false;
    const sync = () => {
      pending = false;
      const drawer = document.querySelector('#slidecarthq .slidecarthq');
      if (!drawer) return;
      syncShipping(drawer);
      syncSaleRecommendations(drawer);
      refreshLegacySaleCart();
      drawer.querySelectorAll('input[type="number"], input[role="spinbutton"]').forEach(input => {
        const quantity = input.parentElement;
        if (quantity.children.length !== 3 || quantity.querySelectorAll('button').length !== 2) return;
        quantity.classList.add('sher-cart-quantity');
        const row = quantity.parentElement;
        if (row.children.length === 2 && !row.querySelector('img') && row.lastElementChild !== quantity) row.classList.add('sher-cart-quantity-row');
      });
      drawer.querySelectorAll('ul').forEach(list => {
        const items = [...list.children];
        if (!items.length || !items.every(item => item.tagName === 'LI' && /^(Colour|Color|Size(?: \(US\))):/.test(item.textContent.trim()))) return;
        list.classList.add('sher-cart-variants');
      });
      drawer.querySelectorAll('h2, h3, p, div, span').forEach(element => {
        if (element.children.length) return;
        const text = element.textContent.trim();
        if (text.toUpperCase() === 'YOU MAY ALSO LIKE') {
          element.classList.add('sher-cart-recommendations-title');
          let section = element.parentElement;
          while (section && section !== drawer && !section.querySelector('.upsell-add')) section = section.parentElement;
          if (section && section !== drawer && !section.querySelector('input[type="number"]')) section.classList.add('sher-cart-recommendations');
        }
        if (text === 'FREE SHIPPING APPLIED!' || text === template.dataset.shippingUnlocked) {
          let section = element.parentElement;
          while (section && section !== drawer && !section.querySelector('[role="progressbar"]')) section = section.parentElement;
          if (section && section !== drawer && !section.querySelector('input[type="number"]')) {
            section.classList.add('sher-cart-shipping');
            element.classList.add('sher-cart-shipping-title');
            if (text !== template.dataset.shippingUnlocked) element.textContent = template.dataset.shippingUnlocked;
          }
        }
      });
      const form = drawer.querySelector('#slidecart-checkout-form');
      const badges = [...drawer.querySelectorAll('.sher-slidecart-protection')];
      const trustRows = [...drawer.querySelectorAll('.sher-checkout-badges')];
      const paymentRows = [...drawer.querySelectorAll('.sher-payment-icons--cart')];
      if (!form || !form.querySelector('button[name="checkout"]')) {
        paymentRows.forEach(row => row.remove());
        trustRows.forEach(row => row.remove());
        badges.forEach(badge => badge.remove());
        return;
      }
      const checkoutButton = form.querySelector('button[name="checkout"]');
      const checkoutLabel = template.dataset.checkoutLabel;
      const walker = document.createTreeWalker(checkoutButton, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) {
        if (/^check\s*out$/i.test(textNode.textContent.trim())) {
          textNode.textContent = checkoutLabel;
        }
      }
      if (checkoutButton.hasAttribute('aria-label') && checkoutButton.getAttribute('aria-label') !== checkoutLabel) {
        checkoutButton.setAttribute('aria-label', checkoutLabel);
      }
      const badge = badges.shift() || template.content.firstElementChild.cloneNode(true);
      badges.forEach(duplicate => duplicate.remove());
      if (form.previousElementSibling !== badge) form.before(badge);
      let paymentRow;
      if (paymentTemplate) {
        paymentRow = paymentRows.shift() || paymentTemplate.content.firstElementChild.cloneNode(true);
        paymentRows.forEach(row => row.remove());
        if (checkoutButton.nextElementSibling !== paymentRow) checkoutButton.after(paymentRow);
      }
      if (trustTemplate) {
        const trustRow = trustRows.shift() || trustTemplate.content.firstElementChild.cloneNode(true);
        trustRows.forEach(row => row.remove());
        const anchor = paymentRow || checkoutButton;
        if (anchor.nextElementSibling !== trustRow) anchor.after(trustRow);
      }
    };
    const observer = new MutationObserver(records => {
      const relevant = records.some(record => {
        if (record.target instanceof Element && record.target.closest('#slidecarthq')) return true;
        return [...record.addedNodes, ...record.removedNodes].some(node =>
          node instanceof Element && (node.id === 'slidecarthq' || node.querySelector('#slidecarthq'))
        );
      });
      if (relevant && !pending) {
        pending = true;
        requestAnimationFrame(sync);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
